import React from "react";
import { hydrateRoot, createRoot } from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { ConfigProvider } from 'antd';
import esES from 'antd/locale/es_ES';

import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'antd-mobile/es/global';

import App from "./App";
import RoutesCode from "./routes";
import "./constants/polyfills";

//import "./index.css";

const container = document.getElementById("root");

const app = (
  <React.StrictMode>
    <ConfigProvider
      locale={esES}
      theme={{
        token: {
          colorPrimary: "#5B88FA",       // Azul corporativo littlecoders
          colorLink: "#5B88FA",
          colorSuccess: "#52c41a",
          colorWarning: "#FA824C",       // Naranja corporativo
          borderRadius: 8,
          fontFamily: "'Poppins', 'Outfit', sans-serif",
          fontSize: 14,
        },
        components: {
          Button: {
            colorPrimary: "#5B88FA",
            colorPrimaryHover: "#4a73e8",
            borderRadius: 20,
            fontWeight: 600,
          },
          Tour: {
            colorPrimary: "#5B88FA",
          },
          List: {
            colorSplit: "#f0f0f0",
          },
        },
      }}
    >
      <RoutesCode />
      <App />
    </ConfigProvider>
  </React.StrictMode>
);

if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}

reportWebVitals();
